import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

export function convertCamelCaseToSnakeCase (input: string | null): string | null {
  if (input) {
    return input.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
  } return null
}

export function convertUndefinedToNull (value: any): any {
  if (value === undefined) {
    return null
  } else {
    return value
  }
}

export function isCamelCase (str: string): boolean {
  return /^[a-z][a-zA-Z0-9]*$/.test(str)
}

export function camelCaseToTitle (value: string): string {
  if (value) {
    const titleCase = value.replace(/([A-Z])/gm, ' $1').trim()
    return titleCase.charAt(0).toUpperCase() + titleCase.slice(1)
  } return ''
}

export function toFloat (value: any): number {
  return isNaN(parseFloat(value as string)) ? value as number : parseFloat(value as string)
}

export function evictCache (
  apolloClient: ApolloClient<NormalizedCacheObject>, queryNames: string[],
  broadcast = true
) {
  const fields: {[key: string]: any} = {}

  for (const queryName of queryNames) {
    fields[queryName] = (refs: any, { DELETE }: any) => DELETE
  }

  return apolloClient.cache.modify({
    id: 'ROOT_QUERY',
    fields,
    broadcast
  })
}

export const camelize = (str: string): string => {
  return str?.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ''
    return index === 0 ? match.toLowerCase() : match.toUpperCase()
  })
}

export const randomColor = () =>
  ('#' + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6)).toUpperCase()

export const hasOpacity = (color: string) => color?.length === 9

export const applyOpacity = (color: string, opacity: number) => {
  if (hasOpacity(color)) return color

  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase()

  return color + alpha
}

export const removeOpacity = (color: string) => (hasOpacity(color) ? color.slice(0, -2) : color)
